import React from "react";

const Filter = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M32.567 2.042v4.44H3.423v-4.44h29.144zM15.018 33.92v-.443c0-4.37-.005-8.74.007-13.109a1.534 1.534 0 00-.434-1.116c-3.15-3.42-6.29-6.848-9.432-10.274-.133-.144-.264-.288-.435-.476h26.54c-.155.171-.276.306-.4.44-3.163 3.45-6.324 6.9-9.494 10.344-.277.302-.405.62-.403 1.033.01 2.74.003 5.48.01 8.22a.591.591 0 01-.226.504c-1.826 1.552-3.646 3.113-5.468 4.67-.068.06-.142.111-.265.206z"
          fill={fill}
      />
    </svg>
);

export default Filter;
